import http from 'utils/http';
import {
  getAcceptRecommendationUrl,
  getPerformanceUrl,
  getRecommendationsOverviewUrl,
  getRecommendationsUrl,
  getRejectRecommendationsUrl
} from './apiUrls';
import { CallPerformanceResponse, RecommendationsOverview, RecommendationsResponse } from './types';

export function getPerformance(
  locationId: string,
  agentId: string,
  params?: Record<string, any>
): Promise<CallPerformanceResponse> {
  return http.get(getPerformanceUrl(locationId, agentId), params);
}

export function getRecommendations(
  locationId: string,
  agentId: string,
  params?: Record<string, any>
): Promise<{
  data: RecommendationsResponse[];
  page?: number;
  per_page?: number;
  total?: number;
  total_pages?: number;
}> {
  return http.get(getRecommendationsUrl(locationId, agentId), params);
}

export function getRecommendationsOverview(locationId: string, agentId: string): Promise<RecommendationsOverview> {
  return http.get(getRecommendationsOverviewUrl(locationId, agentId));
}

export function acceptRecommendation(locationId: string, agentId: string, payload?: Record<string, any>): Promise<any> {
  return http.post(getAcceptRecommendationUrl(locationId, agentId, payload?.id), payload);
}

export function rejectRecommendation(locationId: string, agentId: string, id: string): Promise<any> {
  return http.post(getRejectRecommendationsUrl(locationId, agentId, id), {});
}
